import { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import ApplicationTab from "./ApplicationTab";
import TillageTabComponent from "./TillageTabComponent";
import { Planting } from "./Planting";
import { Harvest } from "./Harvest";

import { styled } from '@mui/system';

const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: '#1976D2', 
    height: '4px',
    borderRadius: '2px',
  },
});

const StyledTab = styled(Tab)({
  textTransform: 'none', 
  fontWeight: 'bold',
  fontSize: '16px',
  color: '#555', 
  '&.Mui-selected': {
    color: '#1976D2', 
  },
  '&:hover': {
    color: '#1976D2', 
    opacity: 0.8,
  },
});

const OperationsCost = () => {
  const [tabIndex, setTabIndex] = useState<number>(0);

  const handleTabChange = (_event: any, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <Box>
      <StyledTabs value={tabIndex} onChange={handleTabChange}>
        <StyledTab label="Tillage" />
        <StyledTab label="Application" />
        <StyledTab label="Planting" />
        <StyledTab label="Harvest" />
      </StyledTabs>
      {tabIndex === 0 && <TillageTabComponent />}
      {tabIndex === 1 && <ApplicationTab />}
      {tabIndex === 2 && <Planting />}
      {tabIndex === 3 && <Harvest />}
    </Box>
  );
};

export default OperationsCost;

